module.exports = __webpack_public_path__ + "static/media/zon.920815d9.png";